import React from 'react'
import { Prompt } from 'react-router-dom'

import LoadingIndicator from 'components/LoadingIndicator'
import { Snackbar } from 'components/Snackbar'
import { useEnableBodyScroll } from 'hooks/useEnableBodyScroll'

import { useSpDeliveryWorkController } from './hooks/useSpDeliveryWorkController'
import { DeliveryWorkView } from './components/DeliveryWorkView'

const UNSAVED_CHANGES_MESSAGE =
  '変更内容が保存されていません。\n「OK」を押すと変更内容が破棄されます。よろしいですか？'

export const SpDeliveryWorkPage: React.FC = () => {
  useEnableBodyScroll()
  const {
    snackbar,
    notify,
    pageState,
    tenantName,
    deliveryReportUid,
    shipmentUid,
    driverPhone,
    isCreating,
    pickBookingId,
    pickBookingOptions,
    visits,
    workTypeSettings,
    deliveryDestinationOptions,
    deliveryHistoryValues,
    isStamping,
    isMutatingVisit,
    handleStartDelivery,
    handleNewDeliveryFromMenu,
    handlePickBookingChange,
    handleDeliveryTenantChange,
    handleSelectDelivery,
    handleClearDelivery,
    handleAddVisit,
    handleStampClick,
    handleDeleteVisit,
    handleMoveVisitUp,
    handleMoveVisitDown,
    isCandidatesLoading,
    isPickBookingUpdating,
    isDeliveryCompleted,
    isDeliveryProcessing,
    confirmType,
    handleCompleteDelivery,
    handleCancelDeliveryComplete,
    handleDeliveryConfirmOk,
    handleDeliveryConfirmClose,
    handleDeliveryWorkSaved,
    hasUnsavedChanges,
    reportVisitDirty,
  } = useSpDeliveryWorkController()

  if (pageState === 'loading') return <LoadingIndicator />
  if (pageState === 'invalid_uid') return <p>URLが無効です</p>
  if (pageState === 'network_error') return <p>通信エラーが発生しました</p>

  return (
    <>
      <DeliveryWorkView
        tenantName={tenantName}
        deliveryReportUid={deliveryReportUid}
        shipmentUid={shipmentUid}
        driverPhone={driverPhone}
        notify={notify}
        pageState={pageState}
        isCreating={isCreating}
        pickBookingId={pickBookingId}
        pickBookingOptions={pickBookingOptions}
        visits={visits}
        workTypeSettings={workTypeSettings}
        deliveryDestinationOptions={deliveryDestinationOptions}
        deliveryHistoryValues={deliveryHistoryValues}
        onStartDelivery={handleStartDelivery}
        onNewDeliveryFromMenu={handleNewDeliveryFromMenu}
        onPickBookingChange={handlePickBookingChange}
        onDeliveryTenantChange={handleDeliveryTenantChange}
        onSelectDelivery={handleSelectDelivery}
        onClearDelivery={handleClearDelivery}
        onAddVisit={handleAddVisit}
        isStamping={isStamping}
        isMutatingVisit={isMutatingVisit}
        onStampClick={handleStampClick}
        onDeleteVisit={handleDeleteVisit}
        onMoveVisitUp={handleMoveVisitUp}
        onMoveVisitDown={handleMoveVisitDown}
        isCandidatesLoading={isCandidatesLoading}
        isPickBookingUpdating={isPickBookingUpdating}
        isDeliveryCompleted={isDeliveryCompleted}
        isDeliveryProcessing={isDeliveryProcessing}
        confirmType={confirmType}
        onCompleteDelivery={handleCompleteDelivery}
        onCancelDeliveryComplete={handleCancelDeliveryComplete}
        onDeliveryConfirmOk={handleDeliveryConfirmOk}
        onDeliveryConfirmClose={handleDeliveryConfirmClose}
        onDeliveryWorkSaved={handleDeliveryWorkSaved}
        onVisitDirtyChange={reportVisitDirty}
      />
      <Prompt when={hasUnsavedChanges} message={UNSAVED_CHANGES_MESSAGE} />
      <Snackbar {...snackbar} />
    </>
  )
}
